import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { format,parse,differenceInSeconds } from 'date-fns';
import addDays from 'date-fns/addDays';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgReportDangerService
    ,FvmsApiDtgDangerDriveService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterSecToTime
    ,FilterDateTime
} from "src/app/shared/filter";

import {
    DtgReportDangerDayDetailComponent
} from "../detail/dtg.report.danger.day.detail.component";

@Component({
    selector: "report-danger-day-main"
    ,templateUrl: './dtg.report.danger.day.main.component.html'
    ,providers: [FilterDist,FilterSecToTime,FilterDateTime]
})
export class DtgReportDangerDayMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    listItem:any[] = [];
    listRuleType:any[];
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    dateTimeInfo:any;
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    selectedDate:any;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    selectedRuleType:number = 0;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiDtgReportDangerService:FvmsApiDtgReportDangerService
        ,private fvmsApiDtgDangerDriveService:FvmsApiDtgDangerDriveService
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private filterDateTime:FilterDateTime
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;
        this.excelPagingInfo.pageSize = 60*60*24;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
            });

        this.fvmsCommonService.subscribeDateInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(dateInfo => {
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListRuleType();
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    getSearchInfo(){
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,searchDateFrom:this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo:this.fvmsCommonService.getDateToIsoReserve()
            ,searchValue:this.searchValue
            ,dtgDriveRuleType:this.selectedRuleType
        };
        return searchInfo;
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgReportDangerService.getListReportDangerDrive(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    reloadListRuleType(){
        this.fvmsApiDtgDangerDriveService.getListRuleType(null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listRuleType = apiResponse.resultValue;
                }
            });
    }

    convSecToMin(durSec:number = 0){
        return Math.floor(durSec / 60);
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    clickSearch(){
        this.reloadListItem();
    }

    changeRuleType(e){
        this.clickSearch();
    }

    clickOpenModalDetail(dtgActionType:DtgActionType,dangerDriveItem:any){
        let modalRef = this.modalService.open(
            DtgReportDangerDayDetailComponent
            ,{
                centered:true
                // ,size: "lg"
                // ,backdrop:"static"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.dtgUnitId = dangerDriveItem.dtgUnitId;
        modalRef.componentInstance.dtgDriveRuleType = dangerDriveItem.dtgDriveRuleType;
        modalRef.componentInstance.dtgRegDtFrom = dangerDriveItem.dtgRegDtFrom;
        modalRef.componentInstance.dtgCarType = dangerDriveItem.dtgCarType;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }
}